import React, { Component } from 'react';
import axios from 'axios';

export default class TipOffModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tipOffPoints: [],
            chosenPoint: props.initialTipOffId || '',
            loading: false,
            saving: false,
            show: true,
            errorMessage: '',
        };
    }

    componentDidMount() {
        this.loadTipOffPoints();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.operative?.id !== this.props.operative?.id) {
            this.setState(
                {
                    chosenPoint: this.props.initialTipOffId || '',
                    tipOffPoints: [],
                    loading: true,
                    errorMessage: '',
                },
                this.loadTipOffPoints
            );
        }
    }

    loadTipOffPoints = async () => {
        const { providerId } = this.props;
        this.setState({ loading: true });

        try {
            const response = await axios.get(`/providers/${providerId}/tip-offs/json`, {
                headers: { Accept: 'application/json' },
            });

            this.setState({
                tipOffPoints: response.data.tipOffOptions || [],
                loading: false,
            });
        } catch (err) {
            console.error(err);
            this.setState({ loading: false });
            alert('Failed to fetch tip-off points.');
        }
    };

    handleChange = (e) => {
        this.setState({ chosenPoint: e.target.value, errorMessage: '' });
    };

    handleSave = async () => {
        const { chosenPoint, tipOffPoints } = this.state;
        const { operative, providerId, onClose } = this.props;

        if (!chosenPoint) {
            this.setState({ errorMessage: 'Please select a tip-off point.' });
            return;
        }

        const selectedTipOff = tipOffPoints.find(tp => tp.id === parseInt(chosenPoint));

        this.setState({ saving: true, errorMessage: '' });

        try {
            await axios.post(`/providers/${providerId}/tip-offs/assign`, {
                tip_off_id: chosenPoint,
                operative_id: operative.id,
                providerId: providerId,
            });

            if (onClose) {
                onClose({
                    success: true,
                    operativeId: operative.id,
                    tipOff: selectedTipOff,
                });
            }

            this.setState({ show: false, saving: false });
        } catch (err) {
            console.error(err);

            this.setState({
                saving: false,
                errorMessage: err.response?.data?.error || 'Failed to assign tip-off.',
            });
        }
    };

    closeModal = () => {
        const { onClose, operative } = this.props;
        const { chosenPoint, tipOffPoints } = this.state;
        const selectedTipOff = tipOffPoints.find(tp => tp.id === parseInt(chosenPoint));

        if (onClose) {
            onClose({
                success: false,
                operativeId: operative.id,
                tipOff: selectedTipOff,
            });
        }

        this.setState({
            show: false,
            errorMessage: '',
            saving: false,
            loading: false,
        });
    };

    render() {
        const { tipOffPoints, chosenPoint, loading, saving, show, errorMessage } = this.state;

        if (!show) return null;

        return (
            <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Assign Tip-Off Point</h5>
                            <button type="button" className="close" onClick={!saving ? this.closeModal : null}>
                                <span>&times;</span>
                            </button>
                        </div>

                        <div className="modal-body">
                            {loading ? (
                                <p>Loading tip-off points...</p>
                            ) : (
                                <>
                                    <select
                                        className="form-control"
                                        value={chosenPoint}
                                        onChange={this.handleChange}
                                        disabled={saving}
                                    >
                                        <option value="">Select a tip-off point</option>
                                        {tipOffPoints.map((tp) => (
                                            <option
                                                key={tp.id}
                                                value={tp.id}
                                            >
                                                {tp.name}
                                            </option>
                                        ))}
                                    </select>
                                    {errorMessage && <div className="text-danger mt-2">{errorMessage}</div>}
                                </>
                            )}
                        </div>

                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={this.closeModal} disabled={saving}>
                                Cancel
                            </button>
                            <button className="btn btn-primary" onClick={this.handleSave} disabled={saving || loading}>
                                {saving ? 'Assigning…' : 'Assign'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
